import { useTranslation } from 'react-i18next';
import {
  ScheduleAppointmentType,
  SchedulingProps,
  SchedulingWarningsProps,
} from '../SchedulingInterface';
import {
  Box,
  Checkbox,
  Divider,
  List,
  ListItemText,
  Typography,
} from '@mui/material';
import { styles } from './styles';
import { useEffect, useState } from 'react';
import { AppError } from '@/utils/AppError';
import { CreditCardDTO } from '@/data/DTOs/schedule/CreditCardDTO';
import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { useCreditCardService } from '@/data/services/useCreditCardService';
import { AppointmentTypeDTO } from '@/data/DTOs/schedule/AppointmentTypeDTO';
import { useAppointmentTypeService } from '@/data/services/schedule/useLocationService';
// import { useSnackbarStoreComponent } from '@/stores/useSnackbar';
//import { MED_STATION_SITE } from '@/constants/constants';

export const SchedulingPayment = ({
  setSchedule,
  schedule,
  setLoading,
  setShowWarning,
  setWarningMessage,
  setIsValid,
  setInternalObject,
  internalObject,
  changeInternalStep,
}: SchedulingProps & SchedulingWarningsProps) => {
  const { t } = useTranslation([
    'schedule',
    'common',
    'signInAddress',
    'creditCard',
  ]);
  const [appointmentsType, setAppointmentsType] = useState<
    AppointmentTypeDTO[]
  >([]);
  const [allPayments, setAllPayments] = useState<CreditCardDTO[]>([]);
  const [selectedPayment, setSelectedPayment] = useState<CreditCardDTO>();

  const { formatGetCreditCardList } = useCreditCardService();
  const { getAppointmentTypeList } = useAppointmentTypeService();
  const scheduleAppointmentType = ScheduleAppointmentType.isOnline(
    schedule.appointmentTypeId
  );

  const selectedAppointmentType = appointmentsType.find(
    (type) => type.id === String(schedule.appointmentTypeId)
  );

  const MED_STATION_SITE = 'https://medstationcard.com';

  const fetchAppointmentType = async () => {
    setLoading(true);
    getAppointmentTypeList()
      .then((items) => {
        setAppointmentsType(items);
      })
      .catch((error: AppError) => {
        setShowWarning(true);
        setWarningMessage(t(error.message));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAppointmentType();
  }, []);

  useEffect(() => {
    setIsValid(selectedPayment != undefined);
    setSchedule({
      ...schedule,
      creditCardId: selectedPayment?.creditCardId,
    });
  }, [selectedPayment]);
  console.log('appointmentsType.price,:::', appointmentsType);

  useEffect(() => {
    setLoading(true);
    formatGetCreditCardList(
      internalObject?.creditCardDTO?.creditCardId ?? schedule.creditCardId,
      schedule.locationId || '',
      schedule.appointmentTypeId.toString()
    )
      .then((allPayments) => {
        setAllPayments(allPayments);

        const filteredPayments = scheduleAppointmentType
          ? allPayments.filter((payment) => payment.creditCardId !== '')
          : allPayments;

        setAllPayments(filteredPayments);

        const paymentSelected = filteredPayments.find(
          (payment) => payment.creditCardId == schedule.creditCardId
        );
        const creditCardSelected =
          internalObject.creditCardDTO != undefined
            ? internalObject.creditCardDTO
            : allPayments.length > 1
            ? allPayments[1]
            : undefined;
        setSelectedPayment(paymentSelected);
        if (paymentSelected?.creditCardId == '') {
          setInternalObject({
            ...internalObject,
            paymentType: 'screen_choose_pay_locally',
            creditCard: '',
            price: String(selectedAppointmentType?.price),
            creditCardDTO: creditCardSelected,
          });
        } else {
          setInternalObject({
            ...internalObject,
            paymentType: 'screen_choose_payment_card',
            creditCard: paymentSelected?.creditCardId,
            price: String(selectedAppointmentType?.price),
            creditCardDTO: creditCardSelected,
          });
        }
      })
      .catch((error: AppError) => {
        console.log('Error fetching credit card list tela pagamento:', error);

        setWarningMessage(t(error.message));
        setShowWarning(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const paymentList = () => {
    return (
      <List sx={styles.list}>
        {allPayments.map((card, index) => paymentItem(card, index))}
      </List>
    );
  };

  const paymentItem = (payment: CreditCardDTO, index: number) => {
    const localPayment = payment.creditCardId == '';
    const noCreditCard = payment.creditCardId == 'none';
    return (
      <Box key={index} sx={styles.paymentCard}>
        <Box
          sx={styles.paymentCard}
          onClick={() => {
            if (noCreditCard) {
              changeInternalStep(true);
              return;
            }
            setSelectedPayment(payment);
            setInternalObject({
              ...internalObject,
              paymentType: localPayment
                ? 'screen_choose_pay_locally'
                : 'screen_choose_payment_card',
              creditCard: localPayment
                ? ''
                : `${payment.banner} **** ${payment.lastDigits}`,
              price: String(selectedAppointmentType?.price),
            });
          }}
        >
          <Checkbox
            checked={payment == selectedPayment}
            icon={<RadioButtonUnchecked sx={styles.checkButton} />}
            checkedIcon={<RadioButtonChecked sx={styles.checkButton} />}
          />
          <ListItemText
            sx={styles.listText}
            primary={
              localPayment
                ? t('screen_choose_pay_locally')
                : t('screen_choose_payment_card')
            }
            secondary={
              <Typography sx={styles.description}>
                {localPayment
                  ? `${t('signInAddress:create_account_address')}: ${
                      internalObject.address
                    }`
                  : noCreditCard
                  ? t('creditCard:screen_credit_card_register_new')
                  : `${payment.banner} **** ${payment.lastDigits}`}
              </Typography>
            }
          />
        </Box>
        {!localPayment && !noCreditCard && (
          <ListItemText
            slotProps={{
              primary: styles.listItemText,
            }}
            sx={styles.changeButton}
            primary={t('common:change')}
            onClick={() => {
              changeInternalStep(true);
            }}
          />
        )}
      </Box>
    );
  };

  function goToMedStationURL() {
    window.open(MED_STATION_SITE);
  }

  const medHelp = () => {
    return (
      <Box sx={styles.medStationBanner}>
        <LocalOfferOutlinedIcon sx={styles.iconLeft} />
        <Box sx={styles.medStationTexts}>
          <Typography sx={styles.medstationCardTitle}>
            {t('screen_schedule_medstationcard_title')}
          </Typography>
          <Typography sx={styles.medstationCardText}>
            {t('screen_schedule_medstationcard_text')}
          </Typography>
        </Box>
        <Typography sx={styles.seeMoreText} onClick={goToMedStationURL}>
          {t('common:look')}
        </Typography>
      </Box>
    );
  };

  const totalValue = () => {
    return (
      <Box sx={styles.footer}>
        <Divider />
        <Box sx={styles.totalValueBox}>
          <Typography sx={styles.totalValueText}>
            {t('screen_choose_pay_total_value')}
          </Typography>
          <Typography>
            U$
            {selectedAppointmentType?.price.toFixed(2)}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={styles.container}>
      {paymentList()} {medHelp()} {totalValue()}
    </Box>
  );
};
